import { useSelector } from 'react-redux'
import { userSlice } from '../../slices/userSlice'

const useIsOwnProfile = (userId: string) => {
  const profile = useSelector(userSlice.selectors.selectCurrentUser)
  return profile?.id === userId
}

export default useIsOwnProfile
